import { Alert, Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import { SERVER_ROWS_PER_PAGE_OPTIONS } from '../../common/constants/paginationConstants';
import {
  ConfirmationDialog,
  CustomButton,
  FormTitleBox,
  PaginationTable,
} from '../../common/components';
import MaterialGroupDrawer from './components/MaterialGroupDrawer';
import MaterialGroupsDataTable from './components/MaterialGroupsDataTable';
import { GROUP_TEXTS } from './constants/materialGroupsConstants';
import { useMaterialGroupsPage } from './hooks/useMaterialGroupsPage';

const MaterialGroups = () => {
  const {
    addArticle,
    articleOptions,
    canSave,
    cancelRemove,
    changeField,
    clearError,
    closeDrawer,
    confirmRemove,
    drawerOpen,
    error,
    form,
    groupToRemove,
    groups,
    handlePageChange,
    handleRowsPerPageChange,
    rowsPerPage,
    handleSearch,
    isLoading,
    isSaving,
    isSearchingArticles,
    loadError,
    openCreateDrawer,
    openEditDrawer,
    page,
    refetch,
    removeArticle,
    requestRemove,
    save,
    search,
    setArticleSearch,
    sort,
    sortTable,
    totalCount,
  } = useMaterialGroupsPage();

  return (
    <Box>
      <FormTitleBox
        title={GROUP_TEXTS.title}
        showButton
        buttonText={GROUP_TEXTS.add}
        buttonIcon={AddIcon}
        onButtonClick={openCreateDrawer}
        showSearch
        searchLabel={GROUP_TEXTS.search}
        searchValue={search}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      {loadError && (
        <Alert
          severity="error"
          action={(
            <CustomButton variant="outlined" size="small" onClick={() => refetch()}>
              {GROUP_TEXTS.retry}
            </CustomButton>
          )}
        >
          {loadError}
        </Alert>
      )}
      {error && !drawerOpen && (
        <Alert severity="error" onClose={clearError}>
          {error}
        </Alert>
      )}

      <MaterialGroupsDataTable
        groups={groups}
        isLoading={isLoading}
        onEdit={openEditDrawer}
        onRemove={requestRemove}
        sort={sort}
        onSort={sortTable}
      />

      {totalCount > 0 && (
        <PaginationTable
          page={page}
          totalPages={Math.max(1, Math.ceil(totalCount / rowsPerPage))}
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={SERVER_ROWS_PER_PAGE_OPTIONS}
          onRowsPerPageChange={handleRowsPerPageChange}
          onPageChange={handlePageChange}
        />
      )}

      <MaterialGroupDrawer
        open={drawerOpen}
        form={form}
        articleOptions={articleOptions}
        isSearchingArticles={isSearchingArticles}
        error={error}
        isSaving={isSaving}
        canSave={canSave}
        onClose={closeDrawer}
        onChange={changeField}
        onArticleSearch={setArticleSearch}
        onAddArticle={addArticle}
        onRemoveArticle={removeArticle}
        onSave={save}
      />

      <ConfirmationDialog
        open={Boolean(groupToRemove)}
        onClose={cancelRemove}
        onConfirm={confirmRemove}
        title={GROUP_TEXTS.confirm}
        message={GROUP_TEXTS.confirmMessage(groupToRemove)}
        confirmText={GROUP_TEXTS.confirmText}
        isLoading={isSaving}
      />
    </Box>
  );
};

export default MaterialGroups;
